<template>
  <DialogTemplateToolkit
    ref="dialog"
    data-qa="criterion-type-dialog"
    :dialog="dialog"
    :disabled="error"
    first_btn="Common.Save"
    second_btn="Common.Skip"
    style="display: contents;"
    :title="element.title"
    @apply="apply"
    @close="close">
    <template #activator-btn>
      <div
        class="add-criteria-data"
        :style="type ? '' : `height: 100%`">
        <HoverAddData
          v-if="!type"
          ref="add_btn"
          :disable="!can_edit"
          :error="!type && error_fields && $t('Tenders.YouMustFillVField')"
          full_height
          :text_class="'pa-3  align-start ' + ( tdColor || '' )"
          :value="type"
          @action="open"/>
        <div
          v-else-if="!!type"
          :key="type + 'is'"
          :class="tdColor || ''"
          v-on="can_edit ? {click: open} : {}">
          <div
            class="px-4 py-2 h7-text flex flex-between"
            :class="{ 'px-3' : dense, }">
            {{ $t(`Tenders.${type}`) }}
            <div class="flex">
              <span
                v-if="type == 'DICTIONARY'"
                class="ml-auto">
                {{ max }}
              </span>
              <InfoIconWithTooltip
                v-if="show_error"
                :content="show_error"
                error/>
            </div>
          </div>

          <template v-if="type == 'DICTIONARY' && values.length">
            <sDivider
              v-if="!dense"
              class="mt-1"/>
            <template v-for="(elem, n) in values">
              <div
                :key="`${elem.id || elem.key}-new`"
                class="flex flex-between"
                :class="[dense ? ' dense-item px-3' : ' px-4', {'mb-2': dense && n != values.length - 1}]">
                <div :class="(!dense ? 'var(--black-color)' : 'secondary__green_not_active') + '--text font-size-12'">
                  {{ elem.title }}
                </div>
                <div :class="(!dense ? 'var(--black-color)' : 'secondary__green_not_active') + '--text text-rigt'">
                  {{ elem.score }}
                </div>
              </div>
              <sDivider
                v-if="n != values.length - 1 && !dense"
                :key="(elem.id || elem.key) + 'div'"/>
            </template>
          </template>
          <div
            v-if="shouldShowInfoBlock"
            :key="item.calculationFormulaError + card.useReducedPrice"
            class="px-4 pb-2 secondary__green_not_active--text"
            :class="{'px-3' : dense}">
            <template v-if="type == 'CALCULATED' && item.calculationFormula">
              <span
                v-if="item.calculationFormulaError"
                :key="item.calculationFormulaError + card.useReducedPrice + item.criterionBindingLevel"
                v-dompurify-html="item.calculationFormulaError"/>
              <ShowFormula
                v-else
                :class="{'opacity-8': growthBook.use_mathjs}"
                :formula-string="item.calculationFormula"
                :use-space="true"/>
            </template>
            <template v-if="type == 'NUMERIC_INPUT' && item.measuringUnit && item.measuringUnit.unitTitle">
              {{ item.measuringUnit.unitTitle }}
            </template>
            <template v-if="has_additional_info">
              <div
                class="py-0 h8-text">
                <div
                  v-if="item.fixedValue"
                  class="mb-3 mt-3">
                  <div
                    class="h8-text secondary__green_not_active--text"
                    data-qa="fixedValue">
                    {{ $t('Tenders.FixedValue') }}:  {{ item.fixedValue }}
                  </div>
                </div>
                <div
                  v-if="item.allowDecimals"
                  class="mb-3 mt-3">
                  <div
                    class="h8-text secondary__green_not_active--text"
                    data-qa="allowed-non-integer-values">
                    {{ $t('Tenders.AllowedNonIntegerValues') }}
                  </div>
                </div>
                <div
                  v-if="item.maxValue || item.minValue || item.maxValue === 0 || item.minValue === 0"
                  class="mb-3 mt-3">
                  <div
                    class="h8-text secondary__green_not_active--text"
                    data-qa="range-of-values">
                    {{ $t('Tenders.RangeOfValues') }}:
                    {{ item.minValue || item.minValue === 0 ? `${$t('Purchasing.From')} ${item.minValue} ${measure} `: '' }}
                    {{ item.maxValue || item.maxValue === 0 ? `${$t('Common.till')} ${item.maxValue} ${measure} ` : '' }}
                  </div>
                </div>
                <div
                  v-if="item.isBestValueDisplayedWeb"
                  class="mb-3 mt-3">
                  <div
                    class="h8-text secondary__green_not_active--text"
                    data-qa="score-direction">
                    {{ $t('Tenders.ShowBestValueToOtherMembers') }}: {{ $t('Tenders.' + item.scoreDirection) }}
                  </div>
                </div>
                <div
                  v-if="type === 'NUMERIC_INPUT' && item.standartValue"
                  class="mb-3 mt-3">
                  <div
                    class="h8-text secondary__green_not_active--text"
                    data-qa="reference-vValue">
                    {{ $t('Tenders.ReferenceValue') }}:  {{ item.standartValue }} {{ measure }}
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
    <template #card-text>
      <CriterionTypeConditions
        ref="data_menu"
        :card="card"
        class="add-criteria-data-dialog"
        :criteria="criteria"
        :error.sync="error"
        :item.sync="element"
        :reduced-price-available="reducedPriceAvailable"/>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import ShowFormula from 'components/common/ShowFormula.vue'
import HoverAddData from 'components/common/blocks/HoverAddData.vue'
import InfoIconWithTooltip from 'components/common/elements/InfoIconWithTooltip.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'
import CriterionTypeConditions from 'components/tenders/critetia/CriterionTypeConditions.vue'

import { criteriasMixin } from 'mixins'

export default {
  name: 'criterionType',
  mixins: [criteriasMixin],
  data() {
    return {
      dialog: false,
      element: {},
      error: true,
      key: 10
    }
  },
  props: {
    item: Object,
    dense: Boolean,
    criteria: Array,
    card: Object,
    can_edit: Boolean,
    tdColor: String,
    error_fields: Boolean,
    reducedPriceAvailable: Boolean,
    /**
     * збереження карти в localStorage
     */
    saveCard: {
      type: Function,
      default: () => {}
    }
  },
  created() {
    this.setElement()
  },
  computed: {
    measure() {
      return this.item.measuringUnit?.unitShortTitle || this.item.measuringUnit?.unitTitle || ''
    },
    type() {
      return this.item.criterionControlType
    },
    values() {
      return this.$_.cloneDeep(this.item?.dictionaryValues || []).sort((a, b) => a.score - b.score)
    },
    has_additional_info() {
      return (this.type == 'NUMERIC_INPUT' || this.type == 'BIG_TEXT') &&
        (
          this.item.standartValue
          || (this.item.minValue ?? false)
          || (this.item.maxValue ?? false)
          || this.item.fixedValue
          || this.item.isBestValueDisplayedWeb
          || this.item.decimals
        )
    },
    shouldShowInfoBlock() {
      return (this.type === 'CALCULATED' && this.item.calculationFormula) ||
             (this.type === 'NUMERIC_INPUT' && this.item.measuringUnit?.unitTitle) ||
             this.has_additional_info
    },
    max() {
      if ( this.values.length ) {
        return Math.max(...this.values.map(el => el.score)) || 0
      }
      return  0
    },
    show_error() {
      let list_error = this.item.criterionControlType == 'DICTIONARY'
          && this.card.useStandardReducedPrice && this.card.useReducedPrice && this.item.useInRedFormula
          && ((this.criteria.reduce((tot, item) => {
            if ( item.criterionControlType == 'DICTIONARY' && item.useInRedFormula) {
              return tot + (item.dictionaryValues.length ? Math.max(...item.dictionaryValues.map(el => +el.score)) : 0)
            }
            return tot
          }, 0) > 99.99  && this.$t('Tenders.DictionaryError'))
            || ( this.item.useInRedFormula
              && !this.item.dictionaryValues.some(el => el.score)
              && this.$t('Validate.CriterionListTypeMustHaveWeight'))),
        formula_error = this.item.criterionControlType == 'CALCULATED'
          && this.item.calculationFormulaError
          && this.item.calculationFormulaError != this.item.calculationFormula
          && this.$t('Tenders.calculationFormulaError')

      if (!formula_error) {
        formula_error = this.$_checkStaticFormula(this.item, this.card.criterias)
      }

      return list_error || formula_error
    }
  },
  methods: {
    setElement() {
      this.element = this.$_.cloneDeep(this.item)
    },
    open() {
      if ( this.can_edit ) {
        this.dialog = true
        this.setElement()
      }
    },
    close() {
      this.$refs.add_btn?.deactivate()
      this.calculationFormulaValidate(this.item)
      this.dialog = false
    },
    apply() {
      if ( this.ckeckAnalogsLocked(this.element ) ) {
        this.element.criterionKind = 'DEFAULT'
      }
      if ( this.element.criterionControlType == 'CALCULATED' && this.element.criterionKind === 'ANALOG' ) {
        this.element.criterionKind = 'DEFAULT'
      }
      if ( !this.checkDisplayCanHide(this.element, this.criteria) &&  this.element.isDisplayed == 'NOT_DISPLAY' ) {
        this.element.isDisplayed = 'ALWAYS'
      }

      Object.entries(this.element).forEach(([key, val]) => {
        this.$set(this.item, key, val)
      })
      this.$emit('action', this.item)
      this.saveCard()
      this.close()
    }
  },
  components: {
    ShowFormula,
    HoverAddData,
    InfoIconWithTooltip,
    DialogTemplateToolkit,
    CriterionTypeConditions
  }
}
</script>
<style lang="scss">
.criteria-data-tooltip {
   .v-list-item {
     min-height: 22px;
   }
}
</style>
